import { useState, useCallback } from 'react';
import { getAllCasilleros, getMiCasillero } from '../services/casillerosService';

export function useCasilleros(handleError, isAdmin = false) {
  const [casilleros, setCasilleros] = useState([]);
  const [totalCasilleros, setTotalCasilleros] = useState(0);
  const [loadingCasilleros, setLoadingCasilleros] = useState(false);
  const [miCasillero, setMiCasillero] = useState(null);

  const fetchCasilleros = useCallback(async () => {
    try {
      setLoadingCasilleros(true);

      let res;
      if (isAdmin) {
        res = await getAllCasilleros();
      } else {
        res = await getMiCasillero();
      }

      console.log('[useCasilleros] respuesta backend:', res);

      if (!res || res.success === false) {
        handleError(res?.mensaje || '❌ Error al cargar casilleros');
        setCasilleros([]);
        setTotalCasilleros(0);
        setMiCasillero(null);
        return { success: false, mensaje: res?.mensaje || 'Error', casilleros: [], casillero: null, total: 0 };
      }

      if (isAdmin) {
        setCasilleros(res.casilleros || []);
        setTotalCasilleros(res.total || res.casilleros?.length || 0);
        return { success: true, mensaje: res.mensaje, casilleros: res.casilleros || [], total: res.total || 0 };
      } else {
        setMiCasillero(res.casillero || null);
        return { success: true, mensaje: res.mensaje, casillero: res.casillero || null };
      }
    } catch (err) {
      handleError(err?.message || '❌ Error al cargar casilleros');
      setCasilleros([]);
      setTotalCasilleros(0);
      setMiCasillero(null);
      return { success: false, mensaje: err?.message || 'Error', casilleros: [], casillero: null, total: 0 };
    } finally {
      setLoadingCasilleros(false);
    }
  }, [isAdmin, handleError]);

  return {
    casilleros,
    totalCasilleros,
    miCasillero,
    loadingCasilleros,
    fetchCasilleros,
    setMiCasillero,
  };
}